/** Course Assign browser routes. */
export const STATIC_COURSE_ASSIGN_BROWSER_ROUTES = {
	COURSE_ASSIGN: "/course-assign",
	SPECIAL_INITIATIVE: "/course-assign/special-initiative",
} as const;
